import React, { useState } from "react";

// Tạo data ở ngoài hoặc lấy từ props
const animals = [
  { id: "elephant", x: 80, y: 40 },
  { id: "frog", x: 210, y: 80 },
  { id: "cat", x: 300, y: 60 },
  { id: "crocodile", x: 50, y: 430 },
  { id: "duck", x: 200, y: 490 },
  { id: "monkey", x: 290, y: 490 },
  { id: "spider", x: 380, y: 500 },
];

const objects = [
  { id: "boat", x: 90, y: 330 },
  { id: "train", x: 160, y: 250 },
  { id: "helicopter", x: 220, y: 200 },
  { id: "car", x: 290, y: 250 },
  { id: "plane", x: 350, y: 320 },
  { id: "van", x: 360, y: 180 },
  { id: "bicycle", x: 400, y: 280 },
];

export default function DrawLineDemo() {
  const [from, setFrom] = useState(null); // {id, x, y}
  const [lines, setLines] = useState([]); // [{from: {...}, to: {...}}]

  // Click animal để chọn from, click object để nối
  const handleAnimalClick = (a) => setFrom(a);
  const handleObjectClick = (o) => {
    if (from) {
      setLines([...lines, { from, to: o }]);
      setFrom(null);
    }
  };

  const width = 520; // set đúng với ảnh thật
  const height = 600;

  return (
    <div className="relative" style={{ width, height }}>
      {/* Ảnh nền */}
      <img
        src="/image.png"
        alt="listening-test"
        className="absolute top-0 left-0"
        style={{ width, height, zIndex: 1 }}
      />

      {/* SVG vẽ line */}
      <svg
        width={width}
        height={height}
        className="absolute top-0 left-0 pointer-events-none"
        style={{ zIndex: 3 }}
      >
        {lines.map((line, idx) => (
          <line
            key={idx}
            x1={line.from.x}
            y1={line.from.y}
            x2={line.to.x}
            y2={line.to.y}
            stroke="#2563eb"
            strokeWidth={4}
            markerEnd="url(#arrowhead)"
          />
        ))}
        {/* Highlight line đang chuẩn bị nối */}
        {from && (
          <circle
            cx={from.x}
            cy={from.y}
            r={10}
            fill="#fbbf24"
            stroke="#2563eb"
            strokeWidth={2}
          />
        )}
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="7"
            refY="3.5"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill="#2563eb" />
          </marker>
        </defs>
      </svg>

      {/* Nút click các animal */}
      {animals.map((a) => (
        <button
          key={a.id}
          style={{
            position: "absolute",
            left: a.x - 16,
            top: a.y - 16,
            width: 32,
            height: 32,
            background: from?.id === a.id ? "#fbbf24" : "#fff",
            border: "2px solid #2563eb",
            borderRadius: "50%",
            zIndex: 4,
            cursor: "pointer",
            opacity: 0.8,
          }}
          onClick={() => handleAnimalClick(a)}
          title={a.id}
        ></button>
      ))}
      {/* Nút click các object */}
      {objects.map((o) => (
        <button
          key={o.id}
          style={{
            position: "absolute",
            left: o.x - 16,
            top: o.y - 16,
            width: 32,
            height: 32,
            background: "#fff",
            border: "2px solid #2563eb",
            borderRadius: "50%",
            zIndex: 4,
            cursor: from ? "pointer" : "default",
            opacity: 0.8,
          }}
          onClick={() => from && handleObjectClick(o)}
          title={o.id}
        ></button>
      ))}
    </div>
  );
}
